import { environment } from 'environments/environment';
import { Lib } from './lib';

export class ApiServiceBase {
	controllerName: string;
	public lib: Lib;

	constructor(_controllerName: string) {
		this.controllerName = _controllerName;
		this.lib = Lib.instance;

		// ApiServiceBase.instance = this;
	}

	get api() { return `${environment.apiUrl}/${this.controllerName}`; }
	delete(id: any) { return this.lib.http.delete(`${this.api}/${id}`) }
	setStatus(id: any, status: number) { return this.lib.http.get(`${this.api}/setStatus/${id}/${status}`); }
	setStatusDontTouchItems(id: any, status: number) { return this.lib.http.get(`${this.api}/setStatusDontTouchItems/${id}/${status}`); }
	clone(id: any) { return this.lib.http.post(`${this.api}/clone`, id); }
	assignTo(id: number, assignToUserId: number, silentMode: boolean = false) {
		return this.lib.http.post(`${this.api}/AssignTo`, { id, assignToUserId }).subscribe(() => {
			if (!silentMode) this.lib.notify('Sahibi değiştirildi', null, 'success');
		});
	}

}
